module.exports = __webpack_public_path__ + "podcast_vikatan_menu-6f0022e48e7151e9132c.svg";